module.exports = __webpack_public_path__ + "static/media/ic-stepper-down.04298076.svg";